/**
 * The unit a price is quoted in ("per dose", "per mL", "per bag").
 *
 * This is the label a clinic picks when it prices an item, and it is the thing
 * that says whether one administration is ONE charge or a charge per measured
 * amount. It is offered as a suggestion list rather than a closed enum: the
 * column is free text (`ServiceCatalog.unit`), live clinics already hold values
 * outside this list, and forcing a migration on their data to add a picker
 * would be the wrong trade. Free text still round-trips — the list only stops
 * new rows fragmenting into "mL" / "ml" / "cc".
 *
 * Ordered by how often a clinic reaches for them, not alphabetically.
 */
export const BILLING_UNIT_OPTIONS: string[] = [
  'per dose',
  'each',
  'per mL',
  'per tablet',
  'per capsule',
  'per vial',
  'per bag',
  'per procedure',
  'per vaccination',
  'per visit',
  'per exam',
  'per test',
  'per treatment',
];
